export default __webpack_public_path__ + "static/media/leahwilliamson-desk.3fd04ccf.mp4";